export default __webpack_public_path__ + "static/media/Clan Bound Bracers of the Far Horizon.32eaea32.jpg";